import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions/index';
import getters from './getters/index';
import mutations from './mutations/index';
import state from './states/index';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js